import { render, staticRenderFns } from "./SubSurveysManagerDialog.vue?vue&type=template&id=2bf27d23"
import script from "./SubSurveysManagerDialog.vue?vue&type=script&lang=ts"
export * from "./SubSurveysManagerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports